export const netlifyFormsEndpoint = process.env.GATSBY_NETLIFY_FORMS_ENDPOINT
